export const formsResources = {
  // A
  ADDRESS: {
    STREET: {
      REQUIRED: 'Le nom de la rue est obligatoire',
      STRING_NOT_EMPTY_AND_TRIMMED:
        'Les espaces ne sont pas autorisés en début et fin de valeur',
    },
    STREETTYPE: {
      REQUIRED: 'Le type de voie est obligatoire',
      STRING_NOT_EMPTY_AND_TRIMMED:
        'Les espaces ne sont pas autorisés en début et fin de valeur',
    },
    ZIP: {
      REQUIRED: 'Le code postal est obligatoire',
      STRING_NOT_EMPTY_AND_TRIMMED:
        'Les espaces ne sont pas autorisés en début et fin de valeur',
    },
    CITY: {
      REQUIRED: 'La ville est obligatoire',
      STRING_NOT_EMPTY_AND_TRIMMED:
        'Les espaces ne sont pas autorisés en début et fin de valeur',
    },
  },
  // B
  BIC: {
    REQUIRED: 'Le BIC est requis',
    MINLENGTH: 'Le BIC doit contenir au moins 8 caractères',
    MAXLENGTH: 'Le BIC ne peut être plus long que 11 caractères',
  },

  BANKNAME: {
    REQUIRED: 'Le Nom de la banque est requis',
  },
  // C
  CAPITAL: {
    REQUIRED: 'Le capital est requis',
  },
  CITY: {
    REQUIRED: 'La ville est requise',
  },
  COMPANYNAME: {
    REQUIRED: 'La raison sociale est requise',
  },
  // D
  DATE: {
    REQUIRED: 'La date est requise',
    INVALID: "Cette date n'existe pas",
    PATTERN: "Veuillez respecter le format 'jj/mm/aaaa'",
    HINT: 'jj/mm/aaaa',
    MIN: "La date minimum n'est pas respectée ({0})",
    MAX: "La date maximum n'est pas respectée ({1})",
  },
  // E
  EMAIL: {
    REQUIRED: "L' email est requis",
    PATTERN: "L' email est invalide",
    ALREADY_USED: "L' email est déja utilisé",
  },
  // F
  FIRSTNAME: {
    REQUIRED: 'Le prénom est requis',
    PATTERN: 'Le prénom est invalide',
    STRING_NOT_EMPTY_AND_TRIMMED:
      'Les espaces ne sont pas autorisés en début et fin de valeur',
  },
  // H
  // I
  IBAN: {
    REQUIRED: "L'IBAN est requis",
  },
  IMMATRICULATION: {
    HINT: 'Avec ou sans espaces, tirets acceptés',
  },
  // J
  FUNCTION: {
    REQUIRED: 'La fonction est requise',
  },
  // L
  LASTNAME: {
    REQUIRED: 'Le nom est requis',
    PATTERN: 'Le nom est invalide',
    STRING_NOT_EMPTY_AND_TRIMMED:
      'Les espaces ne sont pas autorisés en début et fin de valeur',
  },
  LOGIN: {
    REQUIRED: "L'identifiant est requis",
  },
  // O
  OFFICENAME: {
    REQUIRED: 'Le nom de cabinet est requis',
  },
  RAISONSOCIALE: {
    REQUIRED: 'La raison sociale est requise',
    STRING_NOT_EMPTY_AND_TRIMMED:
      'Les espaces ne sont pas autorisés en début et fin de valeur',
  },
  MOBILE: {
    PATTERN: "Le mobile n'est pas valide",
  },
  // P {
  PASSWORD: {
    REQUIRED: 'Le mot de passe est requis',
    INVALID:
      'Le mot de passe doit contenir 8 caractères, dont un chiffre et une majuscule',
    AGAIN: 'Veuillez renseigner le mot de passe une seconde fois',
    NOT_MATCHING: 'Les deux mots de passe ne correspondent pas',
  },
  PHONE: {
    ATLEASTONE_REQUIRED: 'Veuillez renseigner au moins un numéro',
    PATTERN: "Le téléphone n'est pas valide",
  },
  NUMSS: {
    REQUIRED: 'Le n° de sécurité sociale est requis',
    PATTERN: 'Le n° de sécurité sociale doit être composé de 15 chiffres',
  },
  NUMORGAAFFILIATION: {
    REQUIRED: "Le n° de l'organisme d'affiliation est requis",
    PATTERN:
      "Le n° de l'organisme d'affiliation doit être composé de 9 chiffres",
  },
  // S
  SIREN: {
    REQUIRED: 'Le SIREN est requis',
    HINT: 'Le SIREN est composé de 9 chiffres',
    PATTERN: 'Le SIREN est composé de 9 chiffres',
  },
  SIRET: {
    REQUIRED: 'Le SIRET est requis',
    HINT: 'Le SIRET est composé de 14 chiffres',
    PATTERN: 'Le SIRET doit être composé de 14 chiffres',
  },
  BIRTHDAY: {
    MAJORPERSON:
      'Vous devez avoir plus de {0} ans. pour souscrire un contrat de santé.',
    REQUIRED: 'Veuillez renseigner une date de naissance valide.',
    MAX: "Nous sommes désolé mais nous n'avons pas d'offre pour les plus de {0} ans.",
    MIN: 'Vous devez avoir plus de {0} ans. pour souscrire un contrat de santé.',
  },
};
